import { t } from "@lingui/macro"

//Default configuarion for location form fields
const defaultFormConfigs = {
  default: {
    //Level One: Country
    showLevelOne: true,
    requiredLevelOne: true,
    disabledLevelOne: false,
    levelOneName: t({ id: "Country" }),
    levelOneKey: "country",

    //Level Two
    showLevelTwo: false,
    requiredLevelTwo: true,
    disabledLevelTwo: false,
    levelTwoName: t({ id: "Province" }),
    levelTwoKey: "province",

    //Level Three
    showLevelThree: false,
    requiredLevelThree: true,
    disabledLevelThree: false,
    levelThreeName: t({ id: "District" }),
    levelThreeKey: "district",

    //Level Four
    showLevelFour: false,
    requiredLevelFour: true,
    disabledLevelFour: false,
    levelFourName: t({ id: "Administrative Post" }),
    levelFourKey: "administrative_post",

    //Level Five
    showLevelFiveSelector: false,
    showLevelFiveTextInput: false,
    requiredLevelFive: true,
    disabledLevelFive: false,
    levelFiveName: t({ id: "Locality" }),
    levelFiveKey: "locality",

    //Level Six
    showLevelSix: false,
    requiredLevelSix: false,
    disabledLevelSix: false,
    levelSixName: t({ id: "Neighbourhood Name" }),
    levelSixKey: "neighbourhood_name",
  },
  kenya: {
    levelTwoName: t({ id: "County" }),
    levelTwoKey: "county",
    levelThreeName: t({ id: "Sub County" }),
    levelThreeKey: "sub_county",
    showLevelTwo: true,
    showLevelThree: true,
    showLevelFiveSelector: false,
    showLevelFiveTextInput: true,
  },
  ghana: {
    levelTwoName: t({ id: "Region" }),
    levelTwoKey: "region",
    levelThreeName: t({ id: "District" }),
    showLevelTwo: true,
    showLevelThree: true,
    showLevelFiveSelector: false,
    showLevelFiveTextInput: true,
    levelFiveName: t({ id: "Location" }),
  },
  moçambique: {
    showLevelTwo: true,
    showLevelThree: true,
    showLevelFour: true,
    showLevelFiveSelector: true,
    showLevelFiveTextInput: false,
    showLevelSix: true,
  },
  // Add more country-specific configurations as needed eg:
}

export { defaultFormConfigs }
